// extracted by mini-css-extract-plugin
export default {"intro":"welcome_intro__uYqzL","welcomeUser":"welcome_welcomeUser__d8iMr"};